module.exports = __webpack_public_path__ + "img/img2_left.68edd8fa.png";